import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=ade499a4&scoped=true";
import script from "./Notice.vue?vue&type=script&lang=js";
export * from "./Notice.vue?vue&type=script&lang=js";
import style0 from "./Notice.vue?vue&type=style&index=0&id=ade499a4&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "ade499a4", null);
export default component.exports;